export const ROOT = 'admin:root'

export type PermissionCheck = string | string[] | undefined

const LEGACY: Record<string, readonly string[]> = {
  'crm:account:read': ['accounts.read'],
  'crm:account:write': ['accounts.write', 'contacts.write', 'activities.write'],
  'crm:meeting:read': ['activities.write', 'meetings.plan'],
  'crm:meeting:write': ['meetings.plan', 'activities.write'],
  'crm:mail:read': ['accounts.read'],
  'crm:mail:send': ['activities.write'],
  'sales:quote:read': ['quotes.write'],
  'sales:quote:write': ['quotes.write'],
  'sales:order:read': ['orders.write'],
  'sales:order:write': ['orders.write'],
  'sales:order:approve': ['orders.approve'],
}

function holds(perms: readonly string[], code: string) {
  if (perms.includes(code)) return true
  return LEGACY[code]?.some((old) => perms.includes(old)) ?? false
}

export function can(perms: readonly string[], required: PermissionCheck): boolean {
  if (!required || (Array.isArray(required) && required.length === 0)) return true
  if (perms.includes(ROOT)) return true
  const list = Array.isArray(required) ? required : [required]
  return list.some((code) => holds(perms, code))
}

export function allowedTabs<T extends string>(tabs: readonly T[], perms: Partial<Record<T, PermissionCheck>>, check: (p: PermissionCheck) => boolean): T[] {
  return tabs.filter((k) => check(perms[k]))
}

export function resolveTab<T extends string>(tab: T, allowed: readonly T[]): T {
  return allowed.includes(tab) ? tab : (allowed[0] ?? tab)
}
